import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import styled, { ThemeContext } from 'styled-components';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

const Container = styled.div`
  display: flex;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
`;

const StyledLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary.regular};
  font-size: ${({ theme }) => theme.font.sizes.md};
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
`;

const DataCollectionInformation = ({ intl }) => {
    const theme = useContext(ThemeContext);

    const hasTranslation = key => intl.messages && Object.prototype.hasOwnProperty.call(intl.messages, key);
    const { instanceId } = window.appSettings;

    const imprintUrlKey = `developer.account.creation.footer.datacollection.${instanceId}.imprint.url`;
    const imprintLabelKey = `developer.account.creation.footer.datacollection.${instanceId}.imprint.label`;
    const dataProtectionUrlKey = `developer.account.creation.footer.datacollection.${instanceId}.dataProtection.url`;
    const dataProtectionLabelKey = `developer.account.creation.footer.datacollection.${instanceId}.dataProtection.label`;

    const imprintURL = hasTranslation(imprintUrlKey)
        ? intl.formatMessage({ id: imprintUrlKey })
        : undefined;

    const imprintLabel = hasTranslation(imprintLabelKey)
        ? intl.formatMessage({ id: imprintLabelKey })
        : undefined;

    const dataProtectionUrl = hasTranslation(dataProtectionUrlKey)
        ? intl.formatMessage({ id: dataProtectionUrlKey })
        : undefined;

    const dataProtectionLabel = hasTranslation(dataProtectionLabelKey)
        ? intl.formatMessage({ id: dataProtectionLabelKey })
        : undefined;

    return (
        <Container>
            <StyledLink to={imprintURL} theme={theme} data-test="imprint_link">
                {imprintLabel}
            </StyledLink>
            <StyledLink to={dataProtectionUrl} theme={theme} data-test="dataprotection_link">
                {dataProtectionLabel}
            </StyledLink>
        </Container>
    );
};

DataCollectionInformation.propTypes = {
    intl: PropTypes.shape({
        messages: PropTypes.object.isRequired,
        formatMessage: PropTypes.func.isRequired
    }).isRequired
};

export default injectIntl(DataCollectionInformation);